import styled from "styled-components";
import { FLEX } from "styles/flex";
import { COLORS, DARK_THEME_COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import { BackgroundImage, commonLoginHeight } from "../SignCommonStyled";
import { LOGIN_STEP, LOGIN_TAB } from "./LoginContainer";
import { Bottom as SignCommonBottom } from "../SignCommonStyled";
import * as mediaQuery from "components/MediaQuery";

export const BG = styled.div<{ noticeHeight: number }>`
  width: 100%;
  min-height: ${({ noticeHeight = 0 }) => `
    calc(100dvh - ${noticeHeight}px);
  `};
  padding: 20px;
  background: no-repeat fixed center center;
  background-image: ${BackgroundImage};
  background-size: cover;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  .signup-container {
    padding-bottom: 100px;
  }
`;
export const Bottom = styled(SignCommonBottom)<{ center?: boolean }>`
  justify-content: ${({ center }) => (center ? "center" : "space-between")};
`;
export const ResellerCheckedEmailWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  gap: 10px;
  width: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};
  h3 {
    font-size: ${calcRem(17)};
    font-weight: 400;
    line-height: 1.25;
    text-align: center;
    width: 100%;
  }
  .description {
    font-size: ${calcRem(12)};
    font-weight: 400;
    line-height: 1.25;
    text-align: center;
    width: 100%;
    padding-bottom: 10px;
  }
  .input-email-form {
    margin-top: 10px;
  }
  > button {
    width: 100%;
    margin: 20px 0 10px;
  }
`;

export const BigButton = styled.button<{ dw?: boolean; cancel?: boolean }>`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.value === "light" ? COLORS.COMPANY : COLORS.BUTTONS2};
  border-radius: 4px;
  color: ${COLORS.WHITE};
  font-weight: 500;
  /* padding: 18px; */
  height: ${commonLoginHeight};
  font-size: ${calcRem(14)};
  ${FLEX.FlexCenterCenter};
  gap: 4px;

  &:disabled {
    opacity: 0.25;
    cursor: not-allowed;
  }

  > button,
  > span {
    position: relative;
    ${FLEX.FlexCenterCenter};
    color: ${COLORS.WHITE};
    > img {
      width: 13px;
    }
  }
  ${({ dw }) =>
    dw &&
    `
    background-color:#F66214;
  `}
  ${({ cancel }) =>
    cancel &&
    `
    background-color: ${COLORS.BUTTONS1};
  `}
`;
export const ValidateWrapper = styled.span`
  width: 100%;
  ${FLEX.FlexStartCenter};
  font-size: ${calcRem(12)};
  text-align: left;
  /* margin-top: -1px; */
`;
export const LoginContainer = styled.div<{ $hideOffer: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 10px;
  background-color: ${DARK_THEME_COLORS.BACKGROUND}${({ theme }) =>
  theme.value === "light" ? "30" : "90"};
  max-width: 800px;
  width: 100%;
  min-height: 440px;
  transition: all 0.12s ease;
  .inline-block {
    display: inline-block;
  }
  ${({ $hideOffer }) =>
    $hideOffer &&
    `
    ${FLEX.FlexEndCenter};
    flex-direction: column;
    max-width: 400px;
  `}
  ${mediaQuery.isMobile} {
    ${FLEX.FlexStartCenter};
    width: 100%;
    max-width: 400px;
    flex-direction:column;
    background-color: ${({ theme }) => theme.COLORS.BACKGROUND};
    min-height: 515px;
    ${({ $hideOffer }) =>
      $hideOffer &&
      `
    min-height: 390px;
  `}
  }
}
`;
export const LoginLogo = styled.div`
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 10px;
  width: 100%;
  img {
    width: 70px;
  }
`;
export const CpIcon = styled.div`
  position: absolute;
  top: 13px;
  left: 11px;
  background: rgba(136, 117, 255, 1);
  ${FLEX.FlexCenterCenter};
  color: ${COLORS.WHITE};
  font-size: ${calcRem(10)};
  font-weight: 500;
  width: 18px;
  height: 17px;
  border-radius: 50%;
  ${FLEX.FlexCenterCenter};
  line-height: 1;
`;
export const LoginCopy = styled.p`
  font-size: ${calcRem(13)};
  color: ${COLORS.WHITE}95;
  line-height: 1.25;
  width: 100%;
`;
export const SignUpWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  width: 100%;
  flex-direction: column;
  gap: 20px;
  padding: 20px 40px 40px;
  grid-row: 2 / 3;
  grid-column: 1 / 2;
  > h3 {
    text-align: center;
    position: relative;
    overflow: hidden;
    color: ${COLORS.WHITE};
    font-size: ${calcRem(14)};
    width: 100%;
    span {
      padding: 0 10px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        right: 100%;
        width: 400px;
        height: 1px;
        background: ${COLORS.WHITE};
      }
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 100%;
        width: 400px;
        height: 1px;
        background: ${COLORS.WHITE};
      }
    }
  }
  > button {
    width: 100%;
  }
  ${mediaQuery.isMobile} {
    grid-row: auto;
    grid-column: auto;
    padding: 30px 20px 20px;
    gap: 15px;
    h3 {
      color: ${({ theme }) => theme.COLORS.WHITE};
      span {
        &::before {
          background: ${({ theme }) => theme.COLORS.WHITE};
        }
        &::after {
          background: ${({ theme }) => theme.COLORS.WHITE};
        }
      }
    }
  }
`;
export const LoginInner = styled.div`
  min-height: 250px;
  width: 100%;
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  gap: 20px;
  &.reseller-form-inner {
    min-height: 160px;
  }
  ${mediaQuery.isMobile} {
    min-height: auto;
    justify-content: flex-start;
  }
`;
export const HideOfferButton = styled.button<{
  $step?: LOGIN_STEP;
  $hideOffer?: boolean;
}>`
  position: absolute;
  bottom: 20px;
  left: 0;
  ${FLEX.FlexStartCenter};
  font-size: ${calcRem(12)};
  font-weight: 400;
  gap: 6px;
  padding: 8px 10px;
  line-height: 1;
  color: ${({ theme }) => theme.COLORS.WHITE};
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  span {
    //   padding: 8px 10px;
    //   border-radius: 2px 0 0 2px;
    //   background-color: ${({ theme }) => theme.COLORS.BACKGROUND};
    svg {
      display: block;
    }
  }
  border-radius: 0 2px 2px 0;
  ${mediaQuery.isMobile} {
    left: 0;
    gap: 6px;
    span {
      background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
      padding-right: 0;
    }
    ${({ $step, $hideOffer }) =>
      $step === LOGIN_STEP.INPUT_EMAIL &&
      !$hideOffer &&
      `
    bottom: 215px;
  `}
  }
`;
export const LoginForm = styled.div<{ $hideOffer?: boolean }>`
  position: relative;
  ${FLEX.FlexCenterCenter};
  background-color: ${({ theme }) => theme.COLORS.BACKGROUND};
  flex-direction: column;
  border-radius: 0 10px 10px 0;
  padding: 40px;
  gap: 20px;
  flex: 1;
  grid-row: 1 / 3;
  grid-column: 2 / 3;
  ${({ $hideOffer }) =>
    $hideOffer &&
    `
    border-radius: 10px;
    width: 400px;
    max-width: 100%;
    flex: 1;
  `}
  ${mediaQuery.isMobile} {
    grid-row: auto;
    grid-column: auto;
    padding: 10px 20px 0;
    gap: 10px;
    justify-content: flex-start;
    border-radius: 10px;
    width: 100%;
    position: static;
  }
`;

export const LoginFormTitle = styled.h2`
  font-size: ${calcRem(20)};
  margin-top: -10px;
  font-weight: 500;
  text-align: center;
  width: 100%;
  color: ${({ theme }) => theme.COLORS.WHITE};
  ${mediaQuery.isMobile} {
    padding-top: 10px;
  }
`;

export const LoginInfo = styled.div<{ tab?: LOGIN_TAB }>`
  position: relative;
  width: 100%;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 7px;
  ${({ tab }) => tab === LOGIN_TAB.DW_CLOUD && `min-height: 140px;`}
  color: ${({ theme }) =>
    ({ tab }) =>
      tab === LOGIN_TAB.EMAIL ? "rgba(136,117,255,1)" : theme.COLORS.WHITE};
  text-align: center;
  padding: 15px 20px;
  ${({ tab }) =>
    tab === LOGIN_TAB.EMAIL &&
    `padding-left: 35px;
    img {
      width: 36px;
      vertical-align: middle;
      margin-top: -4px;
    }`}
  border-radius: 3px;
  ${({ tab, theme }) => {
    if (tab === LOGIN_TAB.DW_CLOUD) {
      return `
        background-color: rgba(246,98,20,${
          theme.value === "light" ? 0.1 : 0.5
        });
        border: rgba(246,98,20,1);
        margin-bottom: 15px;
      `;
    }
    if (tab === LOGIN_TAB.EMAIL) {
      return `
        background-color: rgba(136,117,255,${
          theme.value === "light" ? 0.2 : 0.1
        });
        border: rgba(136,117,255,1);
      `;
    }
    if (theme.value === "light") {
      return `
        background-color: rgba(237, 116, 34,0.1);
        border: rgba(237, 116, 34,1);
      `;
    }
    return `
      background-color: rgba(0,138,255,0.5);
      border: rgba(0,138,255,1);
    `;
  }}
  text-align: ${({ tab }) => (tab === LOGIN_TAB.EMAIL ? "left" : "center")};
  h3 {
    font-size: ${calcRem(14)};
    width: 100%;
    font-weight: 500;
    line-height: 1.25;
  }
  svg {
    margin-bottom: 5px;
  }
  p {
    font-size: ${calcRem(12)};
    font-weight: 400;
    line-height: 1.25;
  }
  button {
    font-size: ${calcRem(12)};
    font-weight: 400;
    color: ${COLORS.WHITE};
    text-decoration: underline;
    width: 100%;
    text-align: left;
    ${mediaQuery.isMobile} {
      color: ${({ theme }) => theme.COLORS.WHITE};
    }
  }
`;
export const CloudLoginWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  button {
    width: 100%;
    background: #f66214;
  }
`;
export const LoginTab = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 8px;
  padding: 5px;
  width: 100%;
  background: ${({ theme }) => theme.COLORS.WHITE}10;
  border-radius: 3px;
  button {
  }
`;
export const LoginTabButton = styled.button<{ isSelected: boolean }>`
  flex: 1;
  border-radius: 5px;
  color: ${({ theme, isSelected }) =>
    isSelected ? COLORS.WHITE : theme.COLORS.WHITE};
  font-size: ${calcRem(12)};
  border: ${({ theme, isSelected }) =>
    isSelected ? `0px` : `1px solid ${theme.COLORS.WHITE}20`};
  ${FLEX.FlexCenterCenter};
  ${({ isSelected, theme }) =>
    isSelected &&
    `
    background-color: ${theme.COLORS.BUTTONS2};
  `}
  gap: 6px;
  height: 30px;
  padding-top: 2px;
  svg {
    min-width: 14px;
    max-width: 14px;
    width: 14px;
    margin-top: -3px;
  }
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: no-repeat fixed center center;
  background-image: ${BackgroundImage};
  background-size: cover;
`;

export const LoginIdPWWrapper = styled.div`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
`;
export const EmailBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: ${calcRem(12)};
  border-radius: 14px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  padding: 8px 24px;
`;
export const LoginInputEmailWrapper = styled.div`
  ${FLEX.FlexCenterStart};
  flex-direction: column;
  gap: 20px;
  min-height: 195px;
  width: 100%;
  ${mediaQuery.isMobile} {
    min-height: auto;
  }
`;
export const InputWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  width: 100%;
  flex-direction: column;
  gap: 10px;
  button {
    width: 100%;
  }
`;

export const CheckboxInput = styled.label`
  padding: 5px 0;
`;

export const SpectrumWrapper = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex: 1;
  margin-top: 20px;
  color: ${COLORS.WHITE};

  .cloud-login-inner {
    text-align: center;
    width: 100%;
    font-size: ${calcRem(15)};
    line-height: ${calcRem(22)};
    font-weight: 500;
  }

  .row {
    width: 100%;
    ${FLEX.FlexBetweenCenter};
    flex: 1;
    gap: 10px;

    > div:first-child {
      flex: 2;
      .label {
        min-width: 70px;
      }
    }

    > div:nth-child(2) {
      flex: 1;
    }
  }
`;

export const SpectrumInputWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 10px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  width: 100%;

  .label {
    flex: 1;
    font-size: ${calcRem(13)};
    font-weight: 500;

    max-width: 70px;
  }
  .value {
    flex: 4;
    ${FLEX.FlexStartStart};
    gap: 6px;
  }

  input {
    padding: 6px;
  }
  button {
    padding: 5px 7px;
    font-size: ${calcRem(13)};
  }
`;

export const TitleWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  padding-bottom: 4px;
`;

export const Bubble = styled.div`
  position: relative;

  button {
    padding: 0;
    ${FLEX.FlexCenterCenter};
    color: ${COLORS.WHITE};

    > img {
      width: 14px;
    }
  }
`;
export const BubbleWrapper = styled.div`
  position: absolute;
  z-index: 600;
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
`;

export const SpeectrumLogo = styled.div`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  margin-top: -10px;

  > img {
    width: 280px;
    max-width: 100%;
  }
`;

export const Version = styled.div`
  color: ${({ theme }) => theme.COLORS.LIGHTGRAY};
  font-size: ${calcRem(13)};
  padding-top: 10px;
`;

export const FreeTrialInputBox = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  width: 100%;

  .validate-word {
    text-align: start;
    color: ${COLORS.VALIDATERED};
  }
`;

export const FreeTrialInputWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 8px;
  width: 100%;

  button {
    width: 110px;
    padding: 10px 0;

    * {
      font-size: ${calcRem(13)} !important;
    }
  }
`;

export const PassKeyBox = styled.div`
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  gap: 15px;
  width: 100%;
  button {
    width: 100%;
  }
`;

export const PasskeySetupLink = styled.p`
  font-size: ${calcRem(14)};
  font-weight: 400;
  gap: 4px;
  padding-top: 3px;
  ${FLEX.FlexStartCenter};
  color: ${({ theme }) => theme.COLORS.WHITE};
`;

export const PassKeySetup = styled.div`
  ${FLEX.FlexStartCenter};
  position: relative;
  max-width: 400px;
  margin-bottom: 12px;
  width: 100%;
  padding: 20px 10px 20px 25px;
  background-color: ${(props) =>
    props.theme.value === "light" ? COLORS.WHITE : "#161d27"};
  border-radius: 10px;
  box-shadow: 0px 9px 6px #00000029;
  color: ${({ theme }) => theme.COLORS.WHITE};
  gap: 10px;
  button {
    position: absolute;
    right: 10px;
    top: 10px;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  > svg {
    width: 35px;
    height: 36px;
  }
`;
export const PassKeySetupTitle = styled.div`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 5px;
  h1 {
    font-size: ${calcRem(24)};
    font-weight: 500;
  }
  p {
    font-size: ${calcRem(13)};
    font-weight: 400;
    opacity: 0.5;
  }
`;
